<template>
    <div :class="controlPosition === C.BOTTOM ? 'gallery-bottom-arrows' : 'gallery-sides-arrows'">
        <button
            class="gallery-arrow gallery-arrow--prev"
            type="button"
            :aria-label="`Previous ${itemLabel}`"
            @click.stop="$emit('previous')"
        >
            <Icon icon-name="gallery-arrow-left" />
        </button>
        <button
            class="gallery-arrow gallery-arrow--next"
            type="button"
            :aria-label="`Next ${itemLabel}`"
            @click.stop="$emit('next')"
        >
            <Icon icon-name="gallery-arrow-right" />
        </button>
    </div>
</template>
<script>
import Icon from "@/scripts/common/Icon.vue";
import {GalleryControlsPosition} from "@/scripts/common/enums.js";

export default {
    name: "GalleryArrowButtons",
    components: {
        Icon
    },
    props: {
        controlPosition: {
            type: String,
            default: GalleryControlsPosition.SIDES
        },
        itemLabel: {
            type: String,
            default: "image"
        }
    },
    emits: ["previous", "next"],
    data() {
        return {
            C: GalleryControlsPosition,
        }
    },
}
</script>

<style scoped lang="scss">
.gallery-arrow {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    border: 0;
    border-radius: 8px;

    background: rgba(255, 255, 255, 0.70);
    color: #000000;

    font-size: 34px;
    line-height: 1;
    cursor: pointer;

    &:disabled {
        cursor: default;
        opacity: 0.32;
    }
    &:focus {
        outline: none;
    }
}

.gallery-sides-arrows {
    .gallery-arrow {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        z-index: 2;
    }
}

.gallery-bottom-arrows {
    display: flex;
    align-items: center;
    gap: 12px;
}

.gallery-arrow--prev {
    left: var(--arrow-pos-prev, -16px);
}

.gallery-arrow--next {
    right: var(--arrow-pos-next, -16px);
}

.gallery-layout-module--slider {
    .gallery-sides-arrows {
        --arrow-pos-prev: -76px;
        --arrow-pos-next: -76px;

        @media (max-width: 767px) {
            --arrow-pos-prev: -12px;
            --arrow-pos-next: -12px;
        }
    }

    .gallery-controls {
        &:has(.gallery-bottom-arrows) {
            justify-content: space-between;
        }
    }
}

.gallery-layout-module--carousel {
    .gallery-controls {
        &:has(.gallery-bottom-arrows) {
            justify-content: flex-end;
        }
    }
}
</style>
